import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { SRideTypeSelection } from '@slg/web-customer-shared';
import importedAppConfig from '@/appConfig';
import { useStore } from '@/composables';


const __default__ = {
  name: 'RideTypeSelection',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['clearBookingRequestError'],
  setup(__props, { emit }) {


const store = useStore();
const appConfig = ref<Record<string, any>>({});
appConfig.value = importedAppConfig;

const getAnimalsTransportation = computed(() => store.getters['booking/getAnimalsTransportation']);
const getRideType = computed(() => store.getters['booking/getRideType']);
const getAvailableShuttleType = computed(() => store.getters['opsZone/getAvailableShuttleType']);

function setRideType(newType: string) {
  store.commit('booking/setRideType', newType);
  emit('clearBookingRequestError');
}

return { __sfc: true,emit, store, appConfig, getAnimalsTransportation, getRideType, getAvailableShuttleType, setRideType, SRideTypeSelection }
}

})